import { animate, state, style, transition, trigger } from '@angular/animations'

export const slideAnimation = trigger('slideAnimation', [
    state('collapsed', style({ height: '0px', overflow: 'hidden' })),
    state(
        'expanded',
        style({
            height: '*',
            overflow: 'hidden',
        })
    ),
    transition('expanded <=> collapsed', animate('300ms ease-in-out')),
])
